import { render, staticRenderFns } from "./DatePickerAniversario.vue?vue&type=template&id=3b992736&"
import script from "./DatePickerAniversario.vue?vue&type=script&lang=ts&"
export * from "./DatePickerAniversario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VMenu,VTextField})
